import React from 'react';

function GinSettingsFields({
  settings = {},
  onChange,
  disabled = false,
  idPrefix = 'gin',
}) {
  const winAt = settings.winAt ?? 100;
  const knockMax = settings.knockMax ?? 10;
  const ginBonus = settings.ginBonus ?? 25;
  const undercutBonus = settings.undercutBonus ?? 25;

  const patch = (partial) => {
    onChange?.({
      winAt,
      knockMax,
      ginBonus,
      undercutBonus,
      ...partial,
    });
  };

  return (
    <div className="spades-settings-fields gin-settings-fields">
      <label className="spades-host-setting" htmlFor={`${idPrefix}-winAt`}>
        <span>Play to</span>
        <select
          id={`${idPrefix}-winAt`}
          value={winAt}
          disabled={disabled}
          onChange={(e) => patch({ winAt: Number(e.target.value) })}
        >
          {[50, 100, 150, 200, 250].map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </label>
      <label className="spades-host-setting" htmlFor={`${idPrefix}-knock`}>
        <span>Knock max (deadwood)</span>
        <select
          id={`${idPrefix}-knock`}
          value={knockMax}
          disabled={disabled}
          onChange={(e) => patch({ knockMax: Number(e.target.value) })}
        >
          {[0, 5, 10, 15].map((n) => (
            <option key={n} value={n}>{n === 0 ? 'Gin only (0)' : n}</option>
          ))}
        </select>
      </label>
      <label className="spades-host-setting" htmlFor={`${idPrefix}-ginBonus`}>
        <span>Gin bonus</span>
        <select
          id={`${idPrefix}-ginBonus`}
          value={ginBonus}
          disabled={disabled}
          onChange={(e) => patch({ ginBonus: Number(e.target.value) })}
        >
          {[20, 25, 30].map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </label>
      <label className="spades-host-setting" htmlFor={`${idPrefix}-undercut`}>
        <span>Undercut bonus</span>
        <select
          id={`${idPrefix}-undercut`}
          value={undercutBonus}
          disabled={disabled}
          onChange={(e) => patch({ undercutBonus: Number(e.target.value) })}
        >
          {[20, 25, 30].map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </label>
    </div>
  );
}

export default GinSettingsFields;
